namespace GeniuzPOS.Purchase {
    export class PoPurInvoiceDtAppColumns {
        static columnsKey = 'Purchase.PoPurInvoiceDtApp';
    }
}
